import React, { useContext, useEffect } from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { currencyDecimalMap } from "../../helper";
import { StateContext } from "../../store/context";
import { mergeBarChartOptions } from "../../pages/Compare/chartTheme";

const EPSQtrOnQtr: React.FC<any> = ({ data }): React.ReactElement => {
  const { series = [], categories = [] } = data || {};
  const { baseCurrency } = useContext(StateContext);

  const chartData: any = {
    options: mergeBarChartOptions({
      chart: {
        id: "EPSQtrOnQtr",
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            return value
              ? baseCurrency +
                  " " +
                  value.toFixed(currencyDecimalMap[baseCurrency])
              : "";
          },
        },
      },
      xaxis: {
        categories,
      },
      tooltip: {
        shared: true,
        intersect: false,
        hideEmptySeries: false,
      },
      legend: {
        showForSingleSeries: true,
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        formatter: (value: string) => {
          return value
            ? Number(value).toFixed(currencyDecimalMap[baseCurrency])
            : "";
        },
      },
    }),
    chart: {
      type: "bar",
    },
    series,
  };

  useEffect(() => {
    console.log("data", data);
  }, [data]);

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">EPS: Qtr on Qtr</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={550}
      />
    </div>
  );
};

export default EPSQtrOnQtr;
